import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { ChecklistFormControlModule, DynamicFormModule, DynamicFormService, MultiAutocompleteFormControlComponent, TextFormControlModule } from 'core/dynamic-form';
import { SharedComponentsModule } from 'core/shared-components';
import { Subject, distinctUntilChanged, map, startWith, takeUntil } from 'rxjs';
import { designerPaths } from '../../../designer.paths';

import { ScreenUtilsService } from 'core/services';
import { DsgDeepTranslationKey, DsgTranslatePipe } from '../../../pipes/translate.pipe';
import { MobileToolbarContentDirective } from '../../../root/sidenav/mobile-toolbar-content.directive';
import { CrudToolbarComponent } from '../../../shared-components/crud-toolbar/crud-toolbar.component';
import { PageBaseDirective } from '../../../shared-components/page-base.directive';
import { TeamManagementDetailService } from './team-management-detail.service';

@Component({
  selector: 'ss-team-management-detail',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    DsgTranslatePipe,
    DynamicFormModule,
    ReactiveFormsModule,
    TextFormControlModule,
    ChecklistFormControlModule,
    CrudToolbarComponent,
    MatIconModule,
    MatButtonModule,
    MultiAutocompleteFormControlComponent,
    SharedComponentsModule,
    MobileToolbarContentDirective
  ],
  providers: [
    TeamManagementDetailService,
    DynamicFormService,


  ],
  host: {
    class: 'padding-standard full-height display-block'
  },
  hostDirectives: [PageBaseDirective],
  templateUrl: './team-management-detail.component.html',
  styleUrls: ['./team-management-detail.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamManagementDetailComponent {

  readonly #destroy = new Subject<void>();

  readonly loaderKeys = this._teamManagementDetailService.loaderKeys;
  readonly mainFormGroupSubject = this._teamManagementDetailService.mainFormGroupSubject;
  readonly modeSubject = this._teamManagementDetailService.modeSubject;

  readonly loadFn = this._teamManagementDetailService.loadFn;
  readonly initialSelectedItemsObs = this._teamManagementDetailService.initialSelectedItemsObs;

  readonly titleObs = this._teamManagementDetailService.teamIdSubject.pipe(
    map((teamId): DsgDeepTranslationKey => !teamId ? 'ss-entities.team.new-title' : 'ss-entities.team.edit-title')
  )

  readonly displayExprObs = this._teamManagementDetailService.displayExprObs
  readonly isSmallerScreenObs = this._screenUtilsService.isSmallerScreenObs;
  readonly remoteDataSubject = this._teamManagementDetailService.remoteDataSubject
  constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _teamManagementDetailService: TeamManagementDetailService,
    private readonly _router: Router,
    private readonly _screenUtilsService: ScreenUtilsService,

  ) {

  }

  ngOnInit() {

    this._activatedRoute.params.pipe(
      startWith(this._activatedRoute.snapshot.params),
      map((params) => params.teamId),
      takeUntil(this.#destroy),
      distinctUntilChanged()
    )
      .subscribe((teamId) => {

        this._teamManagementDetailService.teamIdSubject.next(teamId);
      })
  }

  delete() {
    this._teamManagementDetailService.delete()
  }

  cancel() {
    this._teamManagementDetailService.cancel()
  }

  save() {
    this._teamManagementDetailService.save()
  }

  back() {
    this._router.navigate([designerPaths.teamManagement]);
  }

  reset() {
    this._teamManagementDetailService.reset()
  }


  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
}
